<template lang="pug">
    include ../media/pug/mixins.pug
    +b.enter-page
        MenuPanel
        +e.inner
            +e.content
                +e.access
                    template(v-if="!getGeneralInfo.isLogin")
                        +e.desc
                            +e.P.text
                                | Для просмотра вам необходимо иметь подтвержденную учетную запись на
                                | #[a(href="https://www.gosuslugi.ru/help/faq/c-1/1") Госуслугах].
                                | После авторизации в ЕСИА вы будете перенаправлены в систему онлайн просмотра.
                        +e.A.form(
                            name='Login RSL'
                            v-bind:href='loginLink'
                            v-if="!getGeneralInfo.isLogin"
                        )
                            +e.BUTTON.btn._enter.btn._theme_fill._size_md {{ $t('LOGIN_SIMPLE') }}
                    template(v-else)
                        template(v-if="!getGeneralInfo.isAvailable")
                            +e.desc
                                +e.P.text По техническим причинам доступ к документу временно закрыт
                        +e.ROUTER-LINK.btn._open.btn._theme_fill._size_md(
                            v-else
                            v-bind:to="{ name: 'Document', params: { id: $route.params.id }, query: {...$route.query} }"
                        ) {{ $t('OPEN_DOCUMENT') }}
</template>

<script>
import RslCardItem from '@RSL/RslCardItem/RslCardItem';
import { mapGetters } from 'vuex';
import entry from '@/helpers/mixins/entry';
import MenuPanel from '@/components/partials/MenuPanel';

const API_URL = process.env.VUE_APP_API_URL;

export default {
    components: {
        RslCardItem,
        MenuPanel
    },
    mixins: [entry],
    computed: {
        ...mapGetters([
            'getGeneralInfo',
            'isMobile',
            'getDocInfo'
        ]),
        loginLink() {
            const { page = 1, rotate = 0, negative = 0 } = this.$route.query;
            const queryToLogin = `?page=${page}&rotate=${rotate}&negative=${negative}`;
            return `${API_URL}/esia-login?redirectUrl=${API_URL}/ru/viewer/${this.$route.params.id}${queryToLogin}`;
        }
    }
};
</script>

<style lang="sass" src="@/media/sass/pages/enter.sass"></style>
